const userPopup = {
  overview: 'Meine Übersicht',
  helloMessage: 'Hallo, {username}',
}

export default userPopup
